import { loadingActions } from 'features';
import { useAppDispatch } from 'app/store';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import TenantPage from 'components/common/TenantPage';
import { useEffect, useState } from 'react';
import { IAccessor } from 'interfaces';
import { useParams } from 'react-router-dom';
import { accessorService } from 'services/api/AccessorService';
import AccessorForm from '../AccessorForm';
import { isTenantAdministrator } from 'components/helpers/IsTenantAdministrator';

export function EditAccessor() {
  const translationPrefix = 'pages.accessories.edit';
  const { accessorId } = useParams();
  const isDisabledEdit = !isTenantAdministrator();

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [accessor, setAccessor] = useState<IAccessor>();
  useEffect(() => {
    accessorService.get(+accessorId).then(setAccessor);
  }, []);

  const updateAccessor = async (values) => {
    dispatch(loadingActions.startLoading());
    accessorService.update(accessor.id, values).then((res) => {
      enqueueSnackbar('Accessorio modificato con successo');
    });
    dispatch(loadingActions.stopLoading());
  };
  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <AccessorForm accessor={accessor} onSubmit={updateAccessor} isDisabledEdit={isDisabledEdit} />
    </TenantPage>
  );
}

export default EditAccessor;
